import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useEffect } from 'react';
import Text from './Text.js';

function DateInput(_a) {
    var value = _a.value, onChange = _a.onChange, inputRef = _a.inputRef, isFocused = _a.isFocused, props = __rest(_a, ["value", "onChange", "inputRef", "isFocused"]);
    useEffect(function () {
        var _a;
        if (isFocused && inputRef.current) {
            (_a = inputRef.current).setSelectionRange.apply(_a, getSelectionRange(value.length));
        }
    }, [inputRef, isFocused, value.length]);
    return (React.createElement(Text, __assign({ inputRef: inputRef, isFocused: isFocused, value: formattedDate(value), onChange: function (e) {
            var normalizedDate = normalizeDate(e.target.value);
            e.target.value = normalizedDate;
            onChange(e);
        } }, props)));
}
function getSelectionRange(length) {
    if (length <= 4) {
        return [length, length];
    }
    if (length <= 6) {
        return [length + 2, length + 2];
    }
    return [length + 4, length + 4];
}
function formattedDate(value) {
    switch (value.length) {
        case 8:
            return value.slice(0, 4) + "\uB144 " + value.slice(4, 6) + "\uC6D4 " + value.slice(6, 8) + "\uC77C";
        case 7:
            return value.slice(0, 4) + "\uB144 " + value.slice(4, 6) + "\uC6D4 " + value.slice(6, 8) + "d\uC77C";
        case 6:
            return value.slice(0, 4) + "\uB144 " + value.slice(4, 6) + "\uC6D4 dd\uC77C";
        case 5:
            return value.slice(0, 4) + "\uB144 " + value.slice(4, 6) + "m\uC6D4 dd\uC77C";
        case 4:
            return value.slice(0, 4) + "\uB144 mm\uC6D4 dd\uC77C";
        case 3:
            return value.slice(0, 4) + "y\uB144 mm\uC6D4 dd\uC77C";
        case 2:
            return value.slice(0, 4) + "yy\uB144 mm\uC6D4 dd\uC77C";
        case 1:
            return value.slice(0, 4) + "yyy\uB144 mm\uC6D4 dd\uC77C";
        default:
            return 'yyyy년 mm월 dd일';
    }
}
var maxDayOfMonth = {
    1: 31,
    2: 29,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
};
// 미래값도 입력이 되어야 하는 경우 두 번째 인자로 뭔가를 받아야 함
function normalizeDate(value) {
    var normalizedDate = value.replace(/[^0-9]/g, '').slice(0, 8);
    if (value.length === 12 && value[value.length - 1] !== '일') {
        normalizedDate = normalizedDate.slice(0, 7);
    }
    var currentDate = new Date();
    var maxYear = currentDate.getFullYear().toString();
    var maxMonth = currentDate.getMonth() + 1 < 10
        ? "0" + (currentDate.getMonth() + 1)
        : (currentDate.getMonth() + 1).toString();
    var maxDay = currentDate.getDate() < 10
        ? "0" + currentDate.getDate()
        : currentDate.getDate().toString();
    var minYear = '1900'.slice(0, normalizedDate.length >= 4 ? 4 : normalizedDate.length);
    var year = normalizedDate.slice(0, 4);
    var month = normalizedDate.slice(4, 6);
    var day = normalizedDate.slice(6, 8);
    if (year) {
        if (Number(year) < Number(minYear.slice(0, year.length))) {
            year = minYear.slice(0, year.length);
        }
        else if (Number(year) >= Number(maxYear.slice(0, year.length))) {
            year = maxYear.slice(0, year.length);
        }
    }
    if (month) {
        if (year === maxYear) {
            if (Number(month) >= Number(maxMonth)) {
                month = maxMonth;
            }
            else if (month === '00') {
                month = '01';
            }
            else if (month.length === 1 && Number(month) > 1) {
                month = '1';
            }
        }
        else if (month.length === 1 && Number(month) > 1) {
            month = '1';
        }
        else if (month.length === 2) {
            if (Number(month) > 12) {
                month = '12';
            }
            else if (month === '00') {
                month = '01';
            }
        }
    }
    if (day) {
        if (year === maxYear && month === maxMonth) {
            if (Number(day) >= Number(maxDay)) {
                day = maxDay;
            }
            else if (day === '00') {
                day = '01';
            }
        }
        else if (day.length === 1 &&
            Number(day) > Number(maxDayOfMonth[Number(month)].toString().slice(0, 1))) {
            day = maxDayOfMonth[Number(month)].toString().slice(0, 1);
        }
        else if (Number(day) > maxDayOfMonth[Number(month)]) {
            day = maxDayOfMonth[Number(month)].toString();
        }
        else if (day === '00') {
            day = '01';
        }
    }
    if (Number(year) % 4 !== 0 && month === '02' && day === '29') {
        day = '28';
    }
    return "" + year + month + day;
}

export { DateInput as default };
